import PropTypes from "prop-types";
import loadable from "@loadable/component";

const LoadablePlayer = loadable(() => import("../../shared/DefaultPlayer"));

function ResourceMediaVideoInternal({ resource, active = true }) {
  const {
    variantPosterStyles,
    variantThumbnailStyles,
    attachmentStyles,
    title,
    allowDownload
  } = resource.attributes;

  const src = attachmentStyles.original;

  if (!src || !active) return null;

  const poster =
    variantPosterStyles.mediumLandscape ??
    variantThumbnailStyles.mediumLandscape;

  const tracks =
    resource.relationships?.textTracks
      ?.map(track => {
        if (!track?.attributes) return null;

        const {
          id,
          attributes: { kind, srclang: lang, cuesUrl, label }
        } = track;

        return {
          id,
          src: cuesUrl,
          kind,
          label,
          lang,
          default: kind === "chapters"
        };
      })
      .filter(Boolean) ?? [];

  const download = allowDownload ? attachmentStyles.original : false;

  return (
    <LoadablePlayer
      title={title}
      src={src}
      poster={poster}
      tracks={tracks}
      download={download}
      viewType="video"
    />
  );
}

ResourceMediaVideoInternal.displayName = "Resource.Media.Video.Internal";

ResourceMediaVideoInternal.propTypes = {
  resource: PropTypes.object.isRequired
};

export default ResourceMediaVideoInternal;
